<template>
  <div v-loading="loading">
    <apply-header :flag="'1'"></apply-header>
    <div class="main" :style="{ 'min-height': getHeight - 80 + 'px' }">
      <Side :step="'2'" v-if="hasLogin"></Side>
      <el-form ref="form" :model="form" label-width="0px" :rules="rules" :inline-message="false">
        <!-- <count-down :minutes="1" @onCountDownEnd="onCountDownEnd" style="color: red" /> -->
        <count-down :minutes="$Constans.abilityMin" @end="onCountDownEnd" style="color: red" />
        <div class="smallBox">
          <div class="viewPDF" style="cursor: none">Quant Ability</div>
          <template v-for="(item, index) in form.quantItems">
            <div :key="`title-${index}`" style="font: 16px bold; paddding-top: 15px" v-html="$options.filters.formatTitle(index, item.title, true)"></div>
            <el-form-item :key="item.id" :prop="item.answer.includes('[') ? `quantItems[${index}].resultArray` : `quantItems[${index}].result`" :ref="item.answer.includes('[') ? `quantItems[${index}].resultArray` : `quantItems[${index}].result`">
              <el-input v-if="item.choiceArray[0] === 'respondent fills in the blank'" style="width: 30%" v-model="item.result" :disabled="isAdmin" />
              <el-checkbox-group v-else-if="item.answer.includes('[')" v-model="item.resultArray" :disabled="isAdmin">
                <el-checkbox size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-checkbox>
              </el-checkbox-group>
              <el-radio-group v-else v-model="item.result" :disabled="isAdmin">
                <el-radio size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </div>
        <div class="smallBox">
          <div class="viewPDF" style="cursor: none">Verbal Ability</div>
          <template v-for="(item, index) in form.verbalItems">
            <div :key="`title-${index}`" style="font: 16px bold; paddding-top: 15px" v-html="$options.filters.formatTitle(index, item.title, true)"></div>
            <el-form-item :key="item.id" :prop="item.answer.includes('[') ? `verbalItems[${index}].resultArray` : `verbalItems[${index}].result`" :ref="item.answer.includes('[') ? `verbalItems[${index}].resultArray` : `verbalItems[${index}].result`">
              <el-input v-if="item.choiceArray[0] === 'respondent fills in the blank'" style="width: 30%" v-model="item.result" :disabled="isAdmin" />
              <el-checkbox-group v-else-if="item.answer.includes('[')" v-model="item.resultArray" :disabled="isAdmin">
                <el-checkbox size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-checkbox>
              </el-checkbox-group>
              <el-radio-group v-else v-model="item.result" :disabled="isAdmin">
                <el-radio size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </div>
        <div class="smallBox">
          <div class="viewPDF" style="cursor: none">Logic(Reasoning) Ability</div>
          <template v-for="(item, index) in form.logicItems">
            <div :key="`title-${index}`" style="font: 16px bold; paddding-top: 15px" v-html="$options.filters.formatTitle(index, item.title, true)"></div>
            <el-form-item :key="item.id" :prop="item.answer.includes('[') ? `logicItems[${index}].resultArray` : `logicItems[${index}].result`" :ref="item.answer.includes('[') ? `logicItems[${index}].resultArray` : `logicItems[${index}].result`">
              <el-input v-if="item.choiceArray[0] === 'respondent fills in the blank'" style="width: 30%" v-model="item.result" :disabled="isAdmin" />
              <el-checkbox-group v-else-if="item.answer.includes('[')" v-model="item.resultArray" :disabled="isAdmin">
                <el-checkbox size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-checkbox>
              </el-checkbox-group>
              <el-radio-group v-else v-model="item.result" :disabled="isAdmin">
                <el-radio size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </div>
        <div class="smallBox">
          <div class="viewPDF" style="cursor: none">Perceptual Ability</div>
          <template v-for="(item, index) in form.perceptualItems">
            <div :key="`title-${index}`" style="font: 16px bold; paddding-top: 15px" v-html="$options.filters.formatTitle(index, item.title, true)"></div>
            <el-form-item :key="item.id" :prop="item.answer.includes('[') ? `perceptualItems[${index}].resultArray` : `perceptualItems[${index}].result`" :ref="item.answer.includes('[') ? `perceptualItems[${index}].resultArray` : `perceptualItems[${index}].result`">
              <el-input v-if="item.choiceArray[0] === 'respondent fills in the blank'" style="width: 30%" v-model="item.result" :disabled="isAdmin" />
              <el-checkbox-group v-else-if="item.answer.includes('[')" v-model="item.resultArray" :disabled="isAdmin">
                <el-checkbox size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-checkbox>
              </el-checkbox-group>
              <el-radio-group v-else v-model="item.result" :disabled="isAdmin">
                <el-radio size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </div>
        <div class="smallBox">
          <div class="viewPDF" style="cursor: none">Spatial Ability</div>
          <template v-for="(item, index) in form.spatialItems">
            <div :key="`title-${index}`" style="font: 16px bold; paddding-top: 15px" v-html="$options.filters.formatTitle(index, item.title, true)"></div>
            <el-form-item :key="item.id" :prop="item.answer.includes('[') ? `spatialItems[${index}].resultArray` : `spatialItems[${index}].result`" :ref="item.answer.includes('[') ? `spatialItems[${index}].resultArray` : `spatialItems[${index}].result`">
              <el-input v-if="item.choiceArray[0] === 'respondent fills in the blank'" style="width: 30%" v-model="item.result" :disabled="isAdmin" />
              <el-checkbox-group v-else-if="item.answer.includes('[')" v-model="item.resultArray" :disabled="isAdmin">
                <el-checkbox size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-checkbox>
              </el-checkbox-group>
              <el-radio-group v-else v-model="item.result" :disabled="isAdmin">
                <el-radio size="medium" :label="choice" v-for="(choice, choiceIndex) in item.choiceArray" :key="choiceIndex">{{ choice }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </div>
        <div style="margin: 20px; margin-top: 30px">
          <el-button class="blueBtn" @click="goPrev">Prev</el-button>
          <el-button class="yellowBtn" style="margin-left: 10px" @click="submitPrepare" v-show="!isAdmin">Next</el-button>
          <el-button class="grayBtn" style="margin-left: 10px" @click="goBack" v-if="hasLogin">Back</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import ApplyHeader from "../../components/ApplyHeader";
import Side from "../../components/Aside.vue";
import CountDown from "../../components/CountDown.vue";
import { chat2Ascii,hasLogin } from "../../../static/js/util";
export default {
  components: { ApplyHeader, Side, CountDown },
  data() {
    return {
      loading: false,
      isAdmin: false,
      abilityItems: [],
      form: {
        quantItems: [],
        verbalItems: [],
        logicItems: [],
        perceptualItems: [],
        spatialItems: [],
      },
      rules: {},
    };
  },
  watch: {
    $route(to, from) {
      console.log(from);
      console.log("邮箱值", localStorage.getItem("email"));
      if (to.path === "/abilityBoard") {
        // this.isAdmin = this.$route.query.type == 0 || this.$route.query.model == "review";
        this.getData();
      }
    },
  },
  computed: {
    getHeight() {
      return document.documentElement.clientHeight;
    },
    hasLogin
  },
  created() {
    this.getData();
  },
  filters: {
    formatTitle(index, title, required) {
      if (true === required) {
        return `<span style="color: red">*</span>${index + 1}. ${title}`;
      } else {
        return `${index + 1}. ${title}`;
      }
    },
  },
  methods: {
    submitPrepare() {
      this.$refs["form"].clearValidate();
      this.$nextTick(() => {
        this.$refs["form"].validate((valid, object) => {
          // console.log("object", object);
          if (valid) {
            // this.form.email = localStorage.getItem("email");
            // console.log(this.form);
            this.submit();
          } else {
            const obj = Object.keys(object)[0];
            // console.log(obj);
            const dom = this.$refs[obj][0];
            // console.log(dom);
            dom.$el.scrollIntoView({
              //滚动到指定节点
              block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
              behavior: "smooth", //值有auto、instant,smooth，缓动动画（当前是慢速的）
            });
            console.log("error submit!!");
            return false;
          }
        });
      });
    },
    submit() {
      let params = this.form;
      params.date = new Date();
      //作为特殊链接进来的时候email从参数中取
      params.email = this.hasLogin?localStorage.getItem("email"):this.$route.query.email;
      params.testId = localStorage.getItem("testid") || 0;
      this.removeAbilityChoiceArray(params);
      this.removeAbilityResultArray(params);
      console.log(params);
      this.$axios
        .post(this.$URL.abilityBoardUrl, params)
        .then((res) => {
          this.loading = false;
          if (res && res.code === 0) {
            localStorage.removeItem("hours");
            localStorage.removeItem("minutes");
            localStorage.removeItem("seconds");

            this.$message.success("Submit Success!");
            // this.goBack();
            this.goPrev();
          }
        })
        .catch((err) => {
          this.$message.error({ message: err.msg });
          this.loading = false;
        });
    },
    goBack() {
      this.$router.push({ path: "/applicantHome" });
    },
    goPrev() {
      let url = !this.hasLogin?window.location.search:''
      this.$router.push({ path: "/resiliencyBoard"+url });
    },
    getData() {
       var email=''
      if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify||this.$route.query.type==0){
        email = this.$route.query.email
        var verify = this.$route.query.verify
        var verifyCode = chat2Ascii(email)
        if(verifyCode!=verify){
            this.$router.push('/login')
            return
        }
        this.isAdmin = true
      }else{
        email = localStorage.getItem("email");
        this.isAdmin = false
      }
      this.loading = true;
      this.$axios
        .get(this.$URL.abilityBoardUrl, { params: { email: email } })
        .then((res) => {
          this.loading = false;
          if (res && res.code == 0) {
            if (res.data) {
              // console.log(res.data);
              const { isNew, quantItems, verbalItems, logicItems, perceptualItems, spatialItems } = res.data;
              this.isAdmin = !isNew;
              //  this.form.quantItems = res.data.filter((item) => item.type == 0);
              this.parseAbilityItems(quantItems, "quantItems");
              // this.form.verbalItems = res.data.filter((item) => item.type == 1);
              this.parseAbilityItems(verbalItems, "verbalItems");
              // this.form.logicItems = res.data.filter((item) => item.type == 2);
              this.parseAbilityItems(logicItems, "logicItems");
              // this.form.perceptualItems = res.data.filter((item) => item.type == 3);
              this.parseAbilityItems(perceptualItems, "perceptualItems");
              // this.form.spatialItems = res.data.filter((item) => item.type == 4);
              this.parseAbilityItems(spatialItems, "spatialItems");
              // console.log(this.form);
              // console.log(this.rules);
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error({ message: err.msg });
        });
    },
    parseAbilityItems(arr, name) {
      console.log(name, arr);
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index];
        // console.log(eval(element.choiceArray));
        let item = {
          id: element.id,
          title: element.title,
          answer: element.answer,
          result: element.result,
          // result: element.answer.split(";")[0],
          choiceArray: eval(element.choices),
          choices: element.choices,
        };
        if (element.answer.includes("[")) {
          item.resultArray = [];
        }
        this.form[name].push(item);
        // console.log(this.form[name]);
        if (element.answer.includes("[")) {
          this.rules[`${name}[${index}].resultArray`] = [{ required: true, message: "Required", trigger: ["change", "blur"] }];
        } else {
          this.rules[`${name}[${index}].result`] = [{ required: true, message: "Required", trigger: ["change", "blur"] }];
        }
      }
    },
    removeAbilityChoiceArray(params) {
      if (params.quantItems) {
        for (let i = 0; i < params.quantItems.length; i++) {
          delete params.quantItems[i].choiceArray;
        }
      }
      if (params.verbalItems) {
        for (let i = 0; i < params.verbalItems.length; i++) {
          delete params.verbalItems[i].choiceArray;
        }
      }
      if (params.logicItems) {
        for (let i = 0; i < params.logicItems.length; i++) {
          delete params.logicItems[i].choiceArray;
        }
      }
      if (params.perceptualItems) {
        for (let i = 0; i < params.perceptualItems.length; i++) {
          delete params.perceptualItems[i].choiceArray;
        }
      }
      if (params.spatialItems) {
        for (let i = 0; i < params.spatialItems.length; i++) {
          delete params.spatialItems[i].choiceArray;
        }
      }
    },
    removeAbilityResultArray(params) {
      if (params.quantItems) {
        for (let i = 0; i < params.quantItems.length; i++) {
          if (params.quantItems[i].answer.includes("[")) {
            params.quantItems[i].result = JSON.stringify(params.quantItems[i].resultArray);
            delete params.quantItems[i].resultArray;
          }
        }
      }
      if (params.verbalItems) {
        for (let i = 0; i < params.verbalItems.length; i++) {
          if (params.verbalItems[i].answer.includes("[")) {
            params.verbalItems[i].result = JSON.stringify(params.verbalItems[i].resultArray);
            delete params.verbalItems[i].resultArray;
          }
        }
      }
      if (params.logicItems) {
        for (let i = 0; i < params.logicItems.length; i++) {
          if (params.logicItems[i].answer.includes("[")) {
            params.logicItems[i].result = JSON.stringify(params.logicItems[i].resultArray);
            delete params.logicItems[i].resultArray;
          }
        }
      }
      if (params.perceptualItems) {
        for (let i = 0; i < params.perceptualItems.length; i++) {
          if (params.perceptualItems[i].answer.includes("[")) {
            params.perceptualItems[i].result = JSON.stringify(params.perceptualItems[i].resultArray);
            delete params.perceptualItems[i].resultArray;
          }
        }
      }
      if (params.spatialItems) {
        for (let i = 0; i < params.spatialItems.length; i++) {
          if (params.spatialItems[i].answer.includes("[")) {
            params.spatialItems[i].result = JSON.stringify(params.spatialItems[i].resultArray);
            delete params.spatialItems[i].resultArray;
          }
        }
      }
    },
    onCountDownEnd() {
      // console.log("end!");
      if (!this.isAdmin) {
        this.$alert("Time out, the test is over!", "Warning", {
          confirmButtonText: "OK",
          showClose: false,
          type: "warning",
          callback: (action) => {
            // this.$message({
            //   type: "info",
            //   message: `action: ${action}`,
            // });
            this.submit();
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.smallBox {
  margin: 20px;
}
.titleImage {
  vertical-align: text-top;
  margin-top: -10px;
}
.viewPDF {
  font-size: 18px;
  left: 12.5%;
}
/deep/ .el-input__inner {
  background-color: #ffffff !important;
}
/deep/ .el-form-item {
  margin-top: 10px;
}
/deep/ .el-textarea__inner {
  width: 70%;
  min-height: 100px !important;
}
@media screen and (max-width: 1200px) {
  .viewPDF {
    font-size: 18px;
    left: 19%;
  }
  /deep/ .el-textarea__inner {
    width: 80%;
    min-height: 100px !important;
  }
}
@media screen and (max-width: 1440px) {
}
</style>